export default "__VITE_ASSET__DACLWaKj__"